define('modules/auth/models/session.model',[
    'underscore',
    'backbone'
], function(_, Backbone){
    var SessionModel = Backbone.Model.extend({
        fetchIntervalInSec: 300,
        urlRoot:function(){
            var base = 'prospector/v1/user/loggedin';
            return window.utils.makeUrl(base);
        },
        initialize: function() {
            this.time = null;
        },
        shouldFetch:function(){
            var date = Date.now();
            return this.time == null
                || (Date.now() - this.time)/1000 > this.fetchIntervalInSec;
        },
        fetch: function(options) {
            this.time = Date.now();
            options = options ? _.clone(options) : {};
            if (options.parse === void 0) options.parse = true;
            var model = this;
            var success = options.success;
            options.success = function(resp, status, xhr) {
                if (!model.set(model.parse(resp), options)) return false;
                if (resp.status == 100) {
                    // $.ajaxSetup({
                    //     headers: {
                    //         'userToken':xhr.getResponseHeader('usertoken')
                    //     }
                    // });
                    // window.userToken = xhr.getResponseHeader('usertoken');
                    // window.utils.createCookie('token', xhr.getResponseHeader('usertoken'),0.01);
                    if(resp.version != undefined){
                        if(window.version == "" || window.version == undefined){
                            window.version = resp.version;
                        }
                        else if(window.version != resp.version){
                            location.reload();
                        }
                    }
                }
                if (success) {
                    success(model, resp, options);
                }
            };
            return this.sync('read', this, options);
        }
    });
    return SessionModel;
});


